<template>
  <div class="block-content flex-box vertical">
    <div class="block-header">
      <a-select
        style="width: 180px"
        placeholder="选择区域"
        @change="selectRegion"
        :options="regionList"
        v-model="currentRegionId"
        :disabled="loading"
      >
      </a-select>
    </div>
    <div class="view-box scroll-area">
      <div class="full-content" v-if="loading">
        <a-spin />
      </div>
      <a-row :gutter="24" class="block-list" v-else-if="blockList.length">
        <a-col
          :span="4"
          v-for="item in blockList"
          :key="item.id"
          @click="selectBlock(item)"
        >
          <div
            class="block-item"
            :class="{ active: item.id == blockId, disabled: item.disabled }"
          >
            <div class="block-name">{{ item.name }}</div>
            <div class="block-count">{{ item.count }}</div>
          </div>
        </a-col>
      </a-row>
      <div class="full-content" v-else>
        <a-empty description="暂无区块" :image="emptyImage"></a-empty>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from "ant-design-vue";

export default {
  name: "BlockList",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    regionId: {
      type: Number,
      default: 0,
    },
    // 区域列表
    regionList: {
      type: Array,
      default: () => [],
    },
    // 区块id
    value: {
      type: Number,
    },
    // 区块列表
    blockList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      emptyImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    currentRegionId: {
      get() {
        return this.regionId;
      },
      set(val) {
        this.$emit("update:regionId", val);
      },
    },
    blockId: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    selectRegion(value) {
      this.$emit("selectRegion", value);
    },
    selectBlock(item) {
      if (item.disabled) return;
      this.blockId = item.id;
      this.$emit("selectBlock", item);
    },
  },
};
</script>

<style lang="less" scoped>
.block-content {
  width: 100%;
  height: 100%;
}
.block-header {
  padding: 32px;
}
.view-box {
  flex: 1;
  min-height: 0;
  padding: 32px;
}
.block-list {
  width: 100%;
}
.block-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
  border: 2px solid #ccc;
  cursor: pointer;
  padding: 10px;

  &.active {
    color: #ffce7e;
    border: 2px solid #ffce7e;
  }
  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
.block-name {
  font-size: 20px;
}
.block-count {
  font-size: 18px;
  margin-top: 12px;
}
.full-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
